module.exports = __webpack_public_path__ + "img/idle-dj-details6.cd93b7c2.png";